import { ButtonType } from '../../button';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef
} from '@angular/core';
import type {
  OnDestroy
} from '@angular/core';

@Component({
  selector: 'ppl-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PplFormActionsComponent implements OnDestroy {
  @Input() saving = false;
  @Input() actionLabel: 'save' | 'saveAs' | 'create' | 'add' | 'remove' | string = 'save';
  @Input() actionVisible = true;
  @Input() actionDisabled = false;
  @Input() actionTooltip?: string;
  @Input() actionButtonType = ButtonType.Button2;
  @Input() cancelLabel: 'cancel' | 'close' | 'undoChanges' = 'cancel';
  @Input() cancelDisabledOnSave = false;
  @Input() cancelVisible = true;
  @Input() cancelDisabled = false;
  @ContentChild('actions', { static: true }) actionsTemplate: TemplateRef<any>;

  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter();

  id: string;

  constructor(
    public changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnDestroy() {
    this.onSave = () => { };
    this.onCancel = () => { };
  }

  onSave = () => { };
  onCancel = () => { };
}
